// #region IMPORT
import { IK_SELECTORS } from 'components/PoseMode/constants';
import { posingStore } from 'stores';
import { GizmoModeType } from 'stores/posingStore';

import type PosingSystem from '../PosingSystem';
import MachineBase from './MachineBase';

// #endregion

export default class RootMachine extends MachineBase {
  name = 'fkroot';
  pSystem!: PosingSystem;

  // #region STATE MACHINE OVERRIDES
  onInit(ps: PosingSystem) {
    this.pSystem = ps;

    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // Start Gizmo
    posingStore.state.gizmoMode = GizmoModeType.Translate;
    posingStore.state.gizmoGlobalRootActive = false;

    this.initGizmo();
  }
  // #endregion

  // #region GIZMO EVENT OVERRIDES
  onGizmoDragStart(): void {
    this.pSystem.poser.selectors.clear();
  }

  onGizmoDragEnd(): void {
    this.pSystem.poser.refresh(posingStore.state.gizmoGlobalRootActive);
  }

  onGizmoTranslate(v: Array<number>): void {
    this.pSystem.poser.setFKPos(v);

    if (posingStore.state.gizmoGlobalRootActive) {
      this.pSystem.poser.refreshSkeleton();
    } else {
      this.pSystem.poser.resolve(); // Run IK
    }
  }

  onGizmoRotate(v: Array<number>): void {
    if (posingStore.state.gizmoMode !== GizmoModeType.Rotate) return;

    this.pSystem.poser.setFKQuat(v);
    if (posingStore.state.gizmoGlobalRootActive) {
      this.pSystem.poser.refreshSkeleton();
    } else {
      this.pSystem.poser.resolve(); // Run IK
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onGizmoModeChange(mode: string): void {
    this.initGizmo();
  }
  // #endregion

  // #region HISTORY EVENT OVERRIDES
  onUndoRedo() {
    this.initGizmo();
  }
  // #endregion

  // #region MISC

  /** Initialize the gizmo's starting position & rotation */
  initGizmo() {
    const sel = IK_SELECTORS[posingStore.state.activeIKChain];
    const rig = this.pSystem.poser.rig;
    const chain = rig[sel.chainKey].chain;
    const ctran = rig.wpose.getWorldTransform(chain.links[0].index);

    switch (posingStore.state.gizmoMode) {
      // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
      case GizmoModeType.Rotate: {
        this.pSystem.gizmo.resetTransform(ctran.pos, ctran.rot).show();
        break;
      }

      // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
      case GizmoModeType.Translate:
        this.pSystem.gizmo.resetTransform(ctran.pos, [0, 0, 0, 1]).show();
        break;

      default:
        posingStore.state.gizmoMode = GizmoModeType.Rotate;
        break;
    }
  }

  // #endregion
}
